import React, { Component } from "react";
//Alert dialog
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { connect } from "react-redux";
import moment from "moment";

class SwtichBranchDialog extends Component {
  tDate = (date) => {
    const { language } = this.props;
    if (language === "english") return date;
    const months = {
      AM: "ص",
      PM: "م",

      "Jan,": "يناير،",
      "Feb,": "فبراير،",
      "Mar,": "مارس،",
      "Apr,": "ابريل،",
      "May,": "مايو،",
      "Jun,": "يونيو،",
      "Jul,": "يوليو،",
      "Aug,": "اغسطس،",
      "Sep,": "سبتمبر،",
      "Oct,": "اكتوبر،",
      "Nov,": "نوفمبر،",
      "Dec,": "ديسمبر،",
    };
    date = date
      .split(" ")
      .map((i) => months[i] || i)
      .join(" ");
    return date;
  };

  render() {
    const { language, product, category } = this.props;
    if (!product && !category) return <></>;

    let scheduled_available_from = null;
    let scheduled_available_until = null;
    if (
      category?.scheduled_available_from &&
      category?.scheduled_available_until &&
      product.scheduled_available_from &&
      product.scheduled_available_until
    ) {
      if (
        category.scheduled_available_from > product.scheduled_available_from
      ) {
        scheduled_available_from = category.scheduled_available_from;
        scheduled_available_until = category.scheduled_available_until;
      } else {
        scheduled_available_from = product.scheduled_available_from;
        scheduled_available_until = product.scheduled_available_until;
      }
    } else if (
      category?.scheduled_available_from &&
      category?.scheduled_available_until
    ) {
      scheduled_available_from = category.scheduled_available_from;
      scheduled_available_until = category.scheduled_available_until;
    } else if (
      product.scheduled_available_from &&
      product.scheduled_available_until
    ) {
      scheduled_available_from = product.scheduled_available_from;
      scheduled_available_until = product.scheduled_available_until;
    }

    return (
      <Dialog
        open={this.props.dialogOpen}
        onClose={(e) => this.props.onClose(e)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{
            textAlign: language === "english" ? "left" : "right",
          }}
        >
          {language === "arabic" ? "تنبيه" : "Note"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{
              textAlign: language == "english" ? "left" : "right",
            }}
          >
            {`${
              language === "arabic"
                ? "هذا المنتج متوفر ابتداء من"
                : "This product is available starting from"
            } ${this.tDate(
              moment(scheduled_available_from, "YYYY-MM-DDTHH:mm:ss").format(
                "D MMM, h:mm A"
              )
            )}`}
          </DialogContentText>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: language == "english" ? "flex-end" : "flex-start",
          }}
        >
          <Button onClick={(e) => this.props.yes(e)} color="primary">
            {language === "arabic" ? "موافق" : "Confirm"}
          </Button>
          <Button onClick={(e) => this.props.onClose(e)} color="primary">
            {language === "arabic" ? "إلغاء" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
  };
};

export default connect(mapStateToProps)(SwtichBranchDialog);
